export type AchievementType = 'point' | 'firstCome' | 'ranking' | 'manual';

export interface AchievementConditionInput {
  type: AchievementType;
  targetValue?: number;
}

/** 학생·교사 화면에 표시하는 달성 조건 문구 */
export const getAchievementConditionText = (a: AchievementConditionInput): string => {
  switch (a.type) {
    case 'point':
      return `누적 포인트 ${a.targetValue ?? 0}점 이상 달성`;
    case 'firstCome':
      return `선착순 ${a.targetValue ?? 0}명 이내에 달성`;
    case 'ranking':
      return `학급 순위 ${a.targetValue ?? 0}위 이내`;
    case 'manual':
      return '담임 선생님이 부여하면 달성됩니다.';
    default:
      return '';
  }
};
